<template>
  <div>
    <Header>Онлайн-запись</Header>
    <div class="container">
      <div class="row">
        <section class="col-xl-12 col-12 wrapper" v-if="!loading">
          <section class="user">
            <div class="information">
              <div class="user--img">
                <div class="user--img--wrapper"><img :src="getPhotoUrl(profile && typeof profile.photoUrl !== 'undefined' && typeof profile.photoUrl ? profile.photoUrl : '')" alt=""></div>
              </div>
              <div class="user--info">
                <div class="info--wrapper">
                  <div class="info--flexable">
                    <h4>{{profile ? profile.name : ''}}</h4>
                    <h6>{{profile ? profile.profession : ''}}</h6>
                    <h6 class="user--phone"><a :href="getPhone(profile ? profile.phone : '')">{{profile ? profile.phone : ''}}</a></h6>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>
        <div v-if="isBookingAllowed && !loading" style="width: 100%;">
          <section class="col-xl-12 col-12 wrapper-white bottom-border">
            <div class="user--rating">
                <div class="rating-cash">
                  <div class="rating-cash-wrapper">
                    <div class="rating-cash--half1">НАЛИЧНЫЕ</div>
                    <div class="rating-cash--half2">КАРТА</div>
                  </div>
                </div>
              </div>
          </section>
          <section class="col-xl-12 col-12 wrapper-white bottom-border">
            <section class="booking-menu">
              <ul class="booking-menu--items">
                <li class="booking-menu--item">
                  <router-link to="/search">
                  <span class="add-service-button">Выбрать услугу</span>
                  <div class="item--information">
                    <span class="add-service-button--service"></span><br>
                    <span class="info--price"></span>
                    <span class="info--hours"></span>
                  </div>
                  </router-link>
                </li>
                <li class="booking-menu--item"><router-link to="/datetime">
                  <span class="booking-menu--item--datetime--button">Дата и время</span>
                  <span class="booking-menu--item--datetime">{{date}} {{hour}}</span>
                </router-link></li>
                <li class="booking-menu--item"><router-link to="/reminder">
                  <span class="menu-item--reminder--button">Напоминание</span>
                  <span class="menu-item--subinfo">{{reminder}}</span>
                </router-link></li>
              </ul>
            </section>
          </section>
          <section class="col-xl-12 col-12 wrapper-gray">
            <section class="address">
              <!-- <div class="address-icon"><img src="/img/address-icon.svg" alt=""></div> -->
              <div class="address-info">
                <div class="address-info--wrapper">
                  <h6>АДРЕС</h6>
                  <span>{{address && typeof address.title && address.title ? address.title : ''}}</span>
                </div>
              </div>
            </section>
          </section>
          <section class="col-xl-12 col-12 wrapper-white bottom-border top-border">
            <section class="comments">
              <textarea
              class="comments--input"
              v-on:keyup="TextAreaDynamicHeight($event)"
              v-on:keydown="TextAreaDynamicHeight($event)"
              v-on:keypress="TextAreaDynamicHeight($event)"
              v-on:change="TextAreaDynamicHeight($event)"
              name="comment"
              rows="1"
              :value="comment"
              placeholder="Комментарий"></textarea>
            </section>
          </section>
          <section class="col-xl-12 col-12 wrapper-gray">
            <section class="total">
              <span>Всего: <span class="total--cost">0 UAH</span> (<span class="total--time">0 час(ов)</span>)</span>
            </section>
            <section class="buttons">
              <router-link to="/form"><button class="btn button-blue">Далее</button></router-link>
            </section>
          </section>
        </div>
        <section v-if="!isBookingAllowed && !loading"
                 class="col-xl-12 col-12 booking-rejected-message">
          Упс... Ваш специалист временно не работает.
        </section>
      </div>
      <footer v-if="isBookingAllowed && !loading">
        <span>Я согласен с <a href="https://www.myclient.me/terms" target="_blank">Условиями использования</a> <br>и <a href="https://www.myclient.me/terms" target="_blank">Политикой конфиденциальности</a></span>
      </footer>
      <!-- POPUP -->
      <Popup/>
    </div>
  </div>
</template>

<style>
.booking-rejected-message {
  text-align: center;
  font-family: 'Avenir Next Cyr';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  padding: 20px 40px;
}

.add-service-button--service {
  color: #000;
}

.add-service-button {
  color: #000;
}

.booking-menu--item--datetime--button {
  color: #000;
}

.total {
  display: none;
  font-family: 'Avenir Next Cyr';
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 134.75%;
  text-align: center;
  margin-top: 2rem;
  text-transform: uppercase;
}

.buttons {
  display: none;
  margin-top: 2rem;
}

.button-blue {
  padding: 1rem 0px;
  width: 100%;
  text-align: center;
  background: #2F80ED;
  backdrop-filter: blur(81.6395px);
  border: none;
  border-radius: 36px;
  color: #fff;
  margin-bottom: 1rem;
}

.button-blue:active {
  background: #ff9500;
  color: #fff;
}

.button-gray {
  padding: 1rem 0px;
  width: 100%;
  text-align: center;
  background: #C4C4C4;
  backdrop-filter: blur(81.6395px);
  border: none;
  border-radius: 36px;
  color: #fff;
  margin-bottom: 1rem;
}

.booking-menu--item--datetime {
  display: none;
}
</style>

<script>
import Popup from '../components/popup.vue';
import Header from '../components/header.vue';
import * as autosize from 'autosize';
import axios from 'axios';
import _ from 'underscore';
import moment from 'moment';

export default {
  name: 'Home',
  data() {
      return {
        loading: true,
        professional: {},
        profile: {},
        address: {},
        servicesList: {},
        isBookingAllowed: false
      };
  },
  metaInfo: {
      title: 'Главная',
      titleTemplate: '%s - Онлайн-запись MyClient',
      htmlAttrs: {
          lang: 'ru',
          amp: false
      }
  },
  beforeMount: function() {
      let vm = this;

      this.$store.dispatch('clientTimezone', this.emptyData.clientTimezone);

      switch(APP_MODE) {
        case MODE_PROFESSIONAL:
          axios.get(`/api/professional/${window.professionalId}/subscription`).then((subscriptionResp) => {
            try {
              this.isBookingAllowed =
                subscriptionResp.data.data.status === 'Active' ||
                subscriptionResp.data.data.status === 'Trial';
              if (!this.isBookingAllowed) {
                this.setUnemployed();
              }
            } catch (e) {}
            this.loading = false;
            axios.get(`/api/professional/${window.professionalId}/details`).then((resp) => {
              const data = resp.data.data;
              this.$store.dispatch('workTime', data.time);
              this.$store.dispatch('professionalId', window.professionalId);
              this.$store.dispatch('professionalName', data.profile.name);
              this.setData(data);
            }).catch(() => {
              this.setUnemployed();
            });
          }).catch(() => {
            this.setUnemployed();
          });
          break;
        case MODE_BOOKING:
          axios.get('/api/auth/check').then((response) => {
            const data = response.data;

            if(data.status === 'error') {
              document.location.href = '/booking/' + window.bookingId + '#/form';
            } else {
              axios.get(`/api/bookings/${window.bookingId}/details`).then((response) => {
                const data = response.data;

                if (data && data.data) {
                  const responseData = data.data;

                  window.professionalId = responseData.professional.id;
                  this.$store.dispatch('professionalId', responseData.professional.id);

                  if (data && data.status) {
                    axios.get(`/api/professional/${window.professionalId}/details`).then((response) => {
                      const responseData = response.data;
                      const data = responseData.data;
                      this.$store.dispatch('workTime', data.time);
                      this.$store.dispatch('professionalName', data.profile.name);
                      this.loading = false;
                      this.isBookingAllowed = true;
                      setTimeout(() => {
                        this.setData(data);
                      });
                    });
                  } else {
                    this.$router.push('/form');
                  }
                } else {
                  document.location = '/404';
                }
              }).catch(() => {
                document.location = '/404';
              });
            }
          });
          break;
        default:
          location.href = '/no-data';
          break;
      }
  },
  mounted: function() {
      if(typeof this.successMessage !== 'undefined' && this.successMessage !== '') {
        this.$noty.success(this.successMessage);
        this.$store.dispatch('successMessage', '');
      }
  },
  beforeCreate: function() {
    document.body.className = 'home';
  },
  methods: {
      setUnemployed () {
        this.loading = false;
        $('body').addClass('unemployed');
      },
      getPhotoUrl (photoUrl) {
        if( photoUrl !== 'undefined' && photoUrl && /^http/.test(String(photoUrl)) ) {
          return photoUrl;
        }
        else if(photoUrl !== 'undefined' && photoUrl) {
          return 'https://res.cloudinary.com/elmy/image/upload/' + photoUrl;
        }

        return '/img/user.png';
      },
      TextAreaDynamicHeight (event) {
        const el = event.target;
        autosize(el);

        this.$store.dispatch('comment', $(el).val());
      },
      getPhone (phone) {
        return phone !== 'undefined' ? 'tel:' + phone : '';
      },
      parseTimeToMinutes (time) {
        time = String(time);
        time = time.replace(':', '');

        return Number(time);
      },
      getTimeFromMins (mins) {
        let num = mins;
        let hours = (num / 60);
        let rhours = Math.floor(hours);
        let minutes = (hours - rhours) * 60;
        let rminutes = Math.round(minutes);

        return (rhours < 10 ? '0' : '' ) + rhours + ":" + rminutes;
      },
      timestrToSec (timestr) {
        var parts = timestr.split(":");
        return (parts[0] * 3600) +
              (parts[1] * 60);
      },
      pad (num) {
        if(num < 10) {
          return "0" + num;
        } else {
          return "" + num;
        }
      },
      formatTime (seconds) {
        return [this.pad(Math.floor(seconds/3600)),
                this.pad(Math.floor(seconds/60)%60),
                ].join(":");
      },
      setData (responseData) {
        this.profile = typeof responseData.profile !== 'undefined' ? responseData.profile : null;
        this.address = typeof responseData.address !== 'undefined' ? responseData.address : null;
        this.servicesList = typeof responseData.services !== 'undefined' ? responseData.services : null;
        this.$store.dispatch('professionalServicesList', this.servicesList);

        let selectedServices = 0;
        let selectedLast = null;

        const services = this.servicesList;

        for(let index in services) {
          let service = services[index];

          if(typeof this.services[service.id] !== 'undefined') {
            if(this.services[service.id] === true) {
              selectedServices++;
              selectedLast = service;
            }
          }

          if(selectedServices === 1) {
            $('.item--information').show();
            $('.add-service-button').hide();

            const jEl = $('.item--information');
            jEl.find('.info--price').show();
            jEl.find('.info--hours').show();

            jEl.find('.add-service-button--service').text(selectedLast.title);
            jEl.find('.info--price').text(
              Math.round(this.sum) + (typeof this.currency !== 'undefined' && this.currency ? ' ' + this.currency : '')
            );

            jEl.find('.info--hours').text(this.hours);
          } else if(selectedServices > 1) {
            $('.item--information').show();
            $('.add-service-button').hide();

            const jEl = $('.item--information');
            jEl.find('.add-service-button--service').text('Выбрано несколько услуг');
            jEl.find('.info--price').show();
            jEl.find('.info--hours').show();


            jEl.find('.info--hours').text(this.hours);
          }
        }

        if(this.date != '') {
          $('.booking-menu--item--datetime').show();
          $('.booking-menu--item--datetime--button').hide();
        }

        if(selectedServices > 0 && this.date != '') {
          $('.total--cost').text(this.sum + ' ' + String(this.currency));
          $('.total--time').text(this.hours + ' час(ов)');

          $('.buttons').fadeIn(300);
          $('.total').fadeIn(300);
        }
      },
      discount(price, service) {
        let total = parseFloat(price);

        if(service && typeof service.discount !== 'undefined' && service.discount) {
          let discount = service.discount;
          if(discount.percent > 0 && total > 0) {
            let percent = parseFloat(discount.percent);
            if(percent) {
              let discountSum = total * (percent / 100);

              total = total - discountSum;
            }
          }
        }

        return Math.round(total);
      },
  },
  computed: {
    emptyData() {
      return this.$store.getters.emptyData;
    },
    search() {
      return this.$store.getters.search;
    },
    currency() {
      return this.$store.getters.currency;
    },
    sum() {
      return this.$store.getters.sum;
    },
    hours() {
      return this.$store.getters.hours;
    },
    minutes() {
      return this.$store.getters.minutes;
    },
    successMessage() {
      return this.$store.getters.successMessage;
    },
    services() {
      return this.$store.getters.services;
    },
    comment() {
      setTimeout(() => {
        autosize($('textarea[name="comment"]'));
      }, 1000);

      return this.$store.getters.comment;
    },
    date() {
      if(this.$store.getters.date === '') {
        return '';
      }

      const date = new Date(this.$store.getters.date);

      return this.days[date.getDay()]
        + ', ' + this.months[date.getMonth()]
        + ' ' + date.getUTCDate() + ', ';
    },
    hour() {
      return this.$store.getters.hour;
    },
    reminder() {
      let title = 'За день до';
      let check = false;

      for(let index in this.reminderList) {
        let item = this.reminderList[index];

        if(index === this.$store.getters.reminder) {

          check = true;
          title = item.title;
          break;
        }
      }

      return title;
    },
    days() {
      return this.$store.getters.days;
    },
    months() {
      return this.$store.getters.months;
    },
    reminderList() {
      return this.$store.getters.reminderList;
    },
    workTime() {
      return this.$store.getters.workTime;
    },
  },
  components: {
    Popup,
    Header
  },
};
</script>
